import React, { useEffect, useState } from 'react';
import { SubFuncionesAdapter } from '../../../../../infraestructure/persistence/rest/SubFuncionesAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboSubFunciones from './combo';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

export const ComboSubFuncionesContainer = (props: any) => {
  
  const api = new SubFuncionesAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [subfunciones, setSubFunciones] = useState<any>([])
	let result: any;
	let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
  
  useEffect(()=>{
    if(!props.disabled){
      if(props.idFuncion ){
        if(props.codArea){
					getSubFuncionesAreaFuncion();
					setSelectedOptions([...[]])
        }else{getSubFuncionesByFuncion();setSelectedOptions([...[]])}
      }else{
        props.dependency ? setSubFunciones([...[]]) : getSubfunciones()
      }
    }
	},[props.disabled,props.idFuncion,props.CodArea,props.dependency])
	
	useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions])

	
  const getSubFuncionesByFuncion = async () => {
		try {
			result = await api.ListarSubFuncionesByFuncion(props.idFuncion);
			if(result.data && result.data!=="")
			{
				setSubFunciones([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  const getSubFuncionesAreaFuncion = async () => {
    let request = {codArea:props.codArea, idFuncion: props.idFuncion, idDN: props.idDN}
		try {
			result = await api.ListarSubFuncionesByAreaFuncion(request);
			if(result.data && result.data!=="")
			{
				setSubFunciones([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

	const getSubfunciones = async () => {
		try {
			result = await api.ListarSubFunciones();
			if(result.data && result.data!=="")
			{
				setSubFunciones([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };


  return <ComboSubFunciones {...{...props,...{selectedOptions:selectedOptions}}} options={subfunciones}/>
};

export default ComboSubFuncionesContainer;